var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.152h16v16H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#072C54",
    d: "M16.184 4.499a1.92 1.92 0 0 0-1.35-1.352c-1.2-.328-6-.328-6-.328s-4.8 0-6 .316a1.96 1.96 0 0 0-1.351 1.364 20.2 20.2 0 0 0-.316 3.688c-.008 1.236.098 2.47.316 3.687a1.92 1.92 0 0 0 1.35 1.352c1.213.329 6 .329 6 .329s4.8 0 6-.316a1.92 1.92 0 0 0 1.352-1.352A20.3 20.3 0 0 0 16.5 8.2c.014-1.24-.091-2.48-.316-3.7m-8.879 5.987v-4.6l3.991 2.3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.152h16v16H.5z"
  })))));
};
export { SvgYoutube as ReactComponent };
export default "/_next/static/images/youtube.svg";